
var ToolMyIP = function() {
    
    var ip = function() {
        $.get('https://digitalv.com.br/meuip.php', function(data) {
            try {
                $("#ip").html(data.ip);
                $("#myIP").val(data.ip);
            } catch (error) {
                
            }
        });
    }

    return {
        init: function() {
            ip();
        }
    };
}();

$(function(){
    ToolMyIP.init();
    
});